import * as Icons from '@mui/icons-material';
import { ElementType } from 'react';

export interface BaseMenuOptions {
  key: string;
  name: string;
  tooltip: string;
  link?: string;
  icon: ElementType;
  validationFunc: string;
}
export interface MenuOptions extends BaseMenuOptions {
  SubMenu?: BaseMenuOptions[];
}

export const Menus: MenuOptions[] = [
  {
    key: 'Home',
    name: 'Health',
    tooltip: 'System Operational Status',
    link: '/',
    icon: Icons.FavoriteBorderOutlined,
    validationFunc: 'default',
  },
  {
    key: 'CostDashboard',
    name: 'Cost Intelligence',
    tooltip: 'Cloud Cost & Attribution',
    link: '/cost',
    icon: Icons.MonetizationOnOutlined,
    validationFunc: 'default',
  },
  {
    key: 'License',
    name: 'License',
    tooltip: 'License Management',
    link: '/licenses',
    icon: Icons.AssignmentTurnedInOutlined,
    validationFunc: 'hasLicenseModuleAccess',
  },
  {
    key: 'Administration',
    name: 'Administration',
    tooltip: 'Administration',
    icon: Icons.AdminPanelSettingsOutlined,
    validationFunc: 'default',

    SubMenu: [
      {
        key: 'EmailAdmin',
        name: 'Email',
        tooltip: 'Email Management',
        link: '/emailadministration',
        icon: Icons.MarkEmailReadOutlined,
        validationFunc: 'hasEmailAccess',
      },
      {
        key: 'KeyVault',
        name: 'Key Vault',
        tooltip: 'Manage Secure Keys',
        link: '/keyvault',
        icon: Icons.VpnKeyOutlined,
        validationFunc: 'hasKeyVaultAccess',
      },
      {
        key: 'Sql Engine',
        name: 'Sql Engine',
        tooltip: 'Sql Engine',
        link: '/sqlengine',
        icon: Icons.BackupTableOutlined,
        validationFunc: 'hasSqlEngineAccess',
      },
      {
        key: 'AccessControl',
        name: 'Access Control',
        tooltip: 'User Access Control',
        link: '/accesscontrol',
        icon: Icons.SupervisorAccountOutlined,
        validationFunc: 'hasAccessControlAccess',
      },
      {
        key: 'Audit',
        name: 'Audit Trail',
        tooltip: 'Audit Trail',
        link: '/audits',
        icon: Icons.AssignmentOutlined,
        validationFunc: 'hasAuditAccess',
      },
    ],
  },
  {
    key: 'Monitoring',
    name: 'Monitoring',
    tooltip: 'System Monitoring',
    icon: Icons.MonitorHeartOutlined,
    validationFunc: 'default',

    SubMenu: [
      {
        key: 'OnCallSupport',
        name: 'On-Call Support',
        tooltip: '24/7 On-Call Support',
        link: '/monitoring',
        icon: Icons.SupportAgentOutlined,
        validationFunc: 'default',
      },
      {
        key: 'Metrics',
        name: 'Metrics',
        tooltip: 'View Tenant Metrics',
        link: '/metrics',
        icon: Icons.InsightsOutlined,
        validationFunc: 'default',
      },
    ],
  },
  {
    key: 'Infrastructure',
    name: 'Infrastructure',
    tooltip: 'Cloud Infrastructure',
    icon: Icons.CloudOutlined,
    validationFunc: 'default',

    SubMenu: [
      {
        key: 'Farm',
        name: 'Manage Farms',
        tooltip: 'Manage Farms',
        link: '/farm',
        icon: Icons.AgricultureOutlined,
        validationFunc: 'default',
      },
      {
        key: 'Customers',
        name: 'Customers',
        tooltip: 'Manage Customers',
        link: '/customer',
        icon: Icons.GroupsOutlined,
        validationFunc: 'default',
      },
      {
        key: 'SqlServer',
        name: 'SQL Server',
        tooltip: 'SQL Server Management',
        link: '/sqlserver',
        icon: Icons.DnsOutlined,
        validationFunc: 'hasStorageAccountAccess',
      },
      {
        key: 'StorageAccount',
        name: 'Storage Account',
        tooltip: 'Storage Account Management',
        link: '/storageaccount',
        icon: Icons.FolderOutlined,
        validationFunc: 'hasStorageAccountAccess',
      },
      {
        key: 'AzureSearchService',
        name: 'Azure Search Service',
        tooltip: 'Azure Search Service Management',
        link: '/searchservice',
        icon: Icons.ContentPasteSearchSharp,
        validationFunc: 'hasAzureSearchServiceAccess',
      },
      {
        key: 'AddOnServices',
        name: 'Add-On Services',
        tooltip: 'Additional Cloud Services',
        link: '/services',
        icon: Icons.ExtensionOutlined,
        validationFunc: 'default',
      },
    ],
  },
];

export const publicMenus: MenuOptions[] = [];

export default Menus;
